import { createSlice } from "@reduxjs/toolkit"

export const searchSuggestSlice = createSlice({
	name: "search_suggest",
	initialState: {
		suggestions: "",
		errors: [],
	},

	reducers: {
		getSuggestions: (state, action) => {
			state.suggestions = action.payload
		},
		getSuggestionsSuccess: (state, action) => {
			state.suggestions = action.payload
		},
		clearSuggestions: (state) => {
			state.suggestions = ""
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})

export const { getSuggestions, getSuggestionsSuccess, clearSuggestions, getErrors } = searchSuggestSlice.actions

export default searchSuggestSlice.reducer
